import { PM2PrintFooterSlot, PM2PrintHeaderSlot } from '@provider/print';
import { units } from '@ui/css';

function mergeContentEnginePrintChunks(contentEnginePrintContent) {
  const sections = [];
  let currentContentEngineSection = makeBlankSection();
  for (const content of contentEnginePrintContent) {
    if (Array.isArray(content)) {
      for (const chunkOrPage of content) {
        if ("chunks" in chunkOrPage) {
          const page = chunkOrPage;
          currentContentEngineSection.pages.push(page);
        } else {
          const chunk = chunkOrPage;
          const currentPage = (() => {
            let page = currentContentEngineSection.pages.at(-1);
            if (page) {
              return page;
            }
            page = makeBlankPage();
            currentContentEngineSection.pages.push(page);
            return page;
          })();
          currentPage.chunks.push(chunk);
        }
      }
    } else {
      if (currentContentEngineSection.pages.length) {
        sections.push(currentContentEngineSection);
      }
      sections.push(content);
      currentContentEngineSection = makeBlankSection();
    }
  }
  if (currentContentEngineSection.pages.length) {
    sections.push(currentContentEngineSection);
  }
  return sections;
}
function makeBlankSection() {
  return {
    pages: [],
    config: {
      slots: {
        header: PM2PrintHeaderSlot,
        footer: PM2PrintFooterSlot
      },
      designSizeInPx: {
        height: 1404,
        width: 993
      }
    }
  };
}
function makeBlankPage() {
  return {
    chunks: [],
    padding: () => ({
      top: units.px(27.5),
      bottom: units.px(25)
    })
  };
}

export { mergeContentEnginePrintChunks };
//# sourceMappingURL=util.merge-content-engine-chunks.js.map
